.sn-who-uses {
  display: flex;
  flex-direction: column;

  &__wrapper {
    display: flex;
    flex-direction: column;
    gap: map-get($spacings, xl);
    background-color: var(--color-system-success-light); // TODO: no exact token
    border-radius: var(--radius-size-lg);
    padding: map-get($spacings, md);

    @include above($breakpoint-desktop) {
      padding: map-get($spacings, xl);
    }

    @include above($breakpoint-desktop-md) {
      padding: map-get($spacings, 2xl);
    }
  }

  &__header {
    padding-bottom: map-get($spacings, xl);
  }

  &__author {
    font-size: map-get($font-sizes, md);
    line-height: map-get($line-heights, lg);
    color: var(--color-text-primary);
    margin: 0;

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, xl);
    }

    strong {
      font-weight: 700;
    }
  }

  &__columns {
    display: flex;
    flex-direction: column;
    gap: map-get($spacings, lg);

    @include above($breakpoint-desktop-md) {
      flex-direction: row;
      gap: map-get($spacings, 2xl);
    }
  }

  &__column-block {
    display: flex;
    flex-direction: column;
    gap: map-get($spacings, md);
    padding: map-get($spacings, lg);
    background-color: var(--color-system-success-light); // match &__wrapper
    border-radius: var(--radius-size-md);

    @include above($breakpoint-desktop) {
      padding: map-get($spacings, xl);
    }
  }

  &__column-title {
    font-size: map-get($font-sizes, lg) !important;
    line-height: map-get($line-heights, lg) !important;
    font-weight: map-get($font-weights, bold) !important;
    margin: 0 !important;

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, xl) !important;
    }
  }

  &__column {
    flex: 1;
    font-weight: 400;
    font-size: map-get($font-sizes, md);
    line-height: map-get($line-heights, lg);
    color: var(--color-text-primary);

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, xl);
    }

    &--last {
      margin-bottom: 0;
    }
  }

  .me-heading--4 {
    font-size: map-get($font-sizes, 2xl);
    margin-bottom: map-get($spacings, 3xl);

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, 3xl);
    }

    @include above($breakpoint-desktop-md) {
      font-size: map-get($font-sizes, 4xl);
    }
  }

  .me-heading--6 {
    font-size: 24px;
    line-height: 32px;
  }

  .me-text {
    font-size: map-get($font-sizes, md);
    line-height: map-get($line-heights, lg);

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, xl);
    }
  }
}
